<ion-img
*ngIf="!exercise.dbExerciseId"
[src]="exercise.imageUrl"
(ionError)="$event.target.src = '/assets/fallback/fitness-icon' + (isDark ? '-dark.svg' : '.svg') "
>
</ion-img>
<ion-img
(ionError)="$event.target.src = '/assets/fallback/fitness-icon' + (isDark ? '-dark.svg' : '.svg') "
  *ngIf="exercise.dbExerciseId"
  [src]="(exercise.dbExerciseId+'/0.jpg') | fetchExerciseImage | async"
></ion-img>
